<template>
    <div>
        <PageTitle title="Selecciona el evento para liberar tu asiento"/>
        <section class="padding-vertical-content ">
            <div class="container">
                <div style="padding: 50px;" v-if="loading">
                    <LoaderComponent/>
                </div>
                <div v-if="eventos && eventos.length > 0">
                    <span class="title">
                        * El importe que percibirá, en el caso de que el club así lo disponga, solo se hará efectivo en caso de que la butaca sea ocupada por otro abonado en el partido liberado. El uso de este importe estará reflejado en las condiciones de compra del club en cada uno de sus productos de la tienda oficial o entradas y abonos de temporada. 
                    </span>
                    <div class="row mt-4">
                        <div class="col-12">
                            <ul class="matches">
                                <template v-for="evento in eventos">
                                    <ListadoDeEventos :key="evento.id" :event="evento" :abono_id="abono_id"/>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tw:flex tw:items-center tw:justify-center tw:text-center tw:min-h-72" v-else>
                    <h2 class="tw:m-0">No hay ningún evento disponible que permita la liberación de butacas.</h2>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import ListadoDeEventos from '@/components/frontend/perfil/liberar_asientos/components/ListadoEventos';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import LoaderComponent from '@/components/preloader/LoaderComponent';

    export default {
        data() {
            return {
                loading: false,
                eventos: null,
                abono_id: this.$route.params.abono_id
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            isLogged() {
                return this.$store.getters.isLogged;
            }
        },
        methods: {
            getEventos() {
                this.loading = true
                const params = {
                    filters : {},
                    abonado_id: this.abono_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.abono.liberar-asientos.events'), params).then(res => {
                    this.eventos = res.data.data;
                    this.loading = false;
                });

            },
        },
        created() {
            if(!this.isLogged){
                this.$router.push({name: 'login'});
            }
            this.getEventos();
        },
        components:  {
            ListadoDeEventos, PageTitle
        }
    }
</script>